module.exports = __webpack_public_path__ + "img/ico_order_luckycoins@3x.0c201663.png";